import React from 'react';
import {Form, Message} from 'semantic-ui-react';
import {injectIntl, intlShape} from 'react-intl';
import Config from 'Config';
import AutoSaveField from './abstract/AutoSaveField.jsx';
import {Beaker2LoginButton, getToken} from 'components/forms/CustomFields/Beaker2LoginButton';

/**
 * AutoSave dropdown that fetches active receipt product campaigns from Beaker2 API
 */
class AutoSaveReceiptCampaignDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            loading: true,
            error: null,
            needsAuth: false
        };
    }

    componentDidMount() {
        this.fetchCampaigns();
    }

    fetchCampaigns = () => {
        const apiUrl = `${Config.WEBSITE_API_URL}admin/receipt-campaign/active`;
        const token = getToken();

        this.setState({loading: true});

        // Use fetch instead of ajaxUtils to avoid CORS issues with Beaker2
        fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? {'Authorization': 'Token: ' + token} : {})
            }
        })
            .then(response => {
                if (response.status === 401 || response.status === 403) {
                    throw Object.assign(new Error('Not authenticated'), {authError: true});
                }
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                const options = data.map((campaign) => ({
                    text: campaign.name,
                    value: "" + campaign.id
                }));

                this.setState({
                    options: options,
                    loading: false,
                    error: null,
                    needsAuth: false
                });
            })
            .catch(error => {
                console.error('Error fetching receipt campaigns:', error);
                this.setState({
                    options: [],
                    loading: false,
                    error: error.authError ? 'You must log in to Beaker2 to load receipt campaigns' : 'Failed to load receipt campaigns',
                    needsAuth: !!error.authError
                });
            });
    }

    handleTokenChange = (token) => {
        if (token) {
            this.fetchCampaigns();
        }
    }

    getValueFromOnChange = (event, data) => {
        return data.value;
    };

    render() {
        return (
            <React.Fragment>
                <AutoSaveField
                    {...this.props}
                    control={Form.Dropdown}
                    options={this.state.options}
                    loading={this.state.loading}
                    currentPlatform={this.props.currentPlatform}
                    getValueFromOnChange={this.getValueFromOnChange}
                    supportsLoading={true}
                    name={this.props.name}
                    helpHeader={this.props.helpHeader}
                    helpContent={this.props.helpContent}
                    onValidationError={this.props.onValidationError}
                    onValidationSuccess={this.props.onValidationSuccess}
                    selection={true}
                />
                {this.state.error && (
                    <Message negative>
                        <p>{this.state.error}</p>
                    </Message>
                )}
                {this.state.needsAuth && (
                    <Beaker2LoginButton onTokenChange={this.handleTokenChange} />
                )}
            </React.Fragment>
        );
    }
}

AutoSaveReceiptCampaignDropdown.propTypes = {
    intl: intlShape
};

export default injectIntl(AutoSaveReceiptCampaignDropdown);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveReceiptCampaignDropdown.jsx